import * as React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from 'src/@/components/ui/dialog';
import { Button } from 'src/@/components/ui/button';
import { AlertCircle } from 'lucide-react';

export default function ModalAlerta({ open, mensagem, onClose, titulo }) {
  return (
    <Dialog open={open} onOpenChange={(value) => { if (!value) onClose(); }}>
      <DialogContent className="sm:max-w-[420px] p-0 gap-0 dark:bg-[#222529] dark:border-[#383838]">
        <div className="px-6 pt-6 pb-4 flex items-start gap-4">
          <div className="w-10 h-10 rounded-lg bg-amber-50 dark:bg-amber-500/10 flex items-center justify-center flex-shrink-0">
            <AlertCircle className="w-5 h-5 text-amber-500" />
          </div>
          <div className="flex-1 pt-1">
            {titulo && (
              <h2 className="text-[15px] font-bold text-gray-900 dark:text-[#D1D2D3] mb-1">
                {titulo}
              </h2>
            )}
            <DialogDescription className="text-[13px] text-gray-600 dark:text-[#ABABAD] leading-relaxed">
              {mensagem}
            </DialogDescription>
          </div>
        </div>
        <DialogFooter className="px-6 py-4 border-t border-gray-100 dark:border-[#383838] bg-gray-50/50 dark:bg-[#1A1D21]/50 rounded-b-lg">
          <Button
            onClick={onClose}
            className="text-[13px] font-semibold h-9 px-4 bg-[#7C3AED] hover:bg-[#6D28D9] text-white"
          >
            Ok
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
